import React, { Component } from 'react';
import authService from './api-authorization/AuthorizeService'
import Calendar from 'react-calendar'
import 'react-calendar/dist/Calendar.css';
import Popup from './popup/reactjs-popup.cjs.development';
import 'reactjs-popup/dist/index.css';
import { FormattedMessage } from 'react-intl';

export class UserOrders extends Component {
  constructor(props) {
    super(props);
    var curDate = new Date();
    curDate.setHours(0,0,0,0);
    this.state = {
      companies: [],
      orders: [],
      history: [],
      calendar: [],
      loading: true,
      userId: ( this.props.params ? this.props.params?.userId : 0 ) || 0,
      companyId: ( this.props.params ? this.props.params?.companyId : 0 ) || 0,
      resources: [],
      duration: 1,
      selectedDate: curDate,
      selectedMonth: curDate,
      phone: '+7',
      userName: '',
      otherBooking: 1,
      bookingText: '',
    };
  }

  async componentDidMount() {
    this.populateOrdersData();
  }

  async cancelOrder(id) {
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/orders/${id}`, {
      method: "DELETE",
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json'
      }
    });
    await response.json();
    this.setState(prevState => ({...prevState, orders: prevState.orders.filter(order => order.id !== id)}));
    this.populateOrdersData();
  }

  getDurWord(days, time) {
    if (days) {
      if (time == 1) {
        return "день";
      }
      return `дн${time>=2 && time<=4?"я":"ей"}`;
    }
    var word = "час";
    if (time > 1) {
      word += time>=2 && time<=4?"а":"ов";
    }
    return word;
  }

  RenderRow(o) {
    return (
      <div class="ordersq">
        <img class="orderimg" src={o.companyImages[0]} alt=""/>
        {o.images.length > 0 ? <img class="orderimg" src={o.images[0]} alt=""/> : <></>}
        {o.cancelable ? <div className="btncancel" style={{borderRadius: ".375rem"}} id="Button_Cancel" onClick={() => this.cancelOrder(o.id)}>X</div> : <></>}
        <div class="ordertxt">
          <h5>{o.resource}</h5>
          <div>Дата: {new Date(o.date).toLocaleString(undefined, {weekday: "long", year: 'numeric', month: '2-digit', day: '2-digit'})}</div>
          {o.start !== 0 || o.end !== 2400 ? <div>В: {Math.floor(o.start/100)}:{(o.start%100).toString().padStart(2, '0')}</div> : <></>}
          {o.start !== 0 || o.end !== 2400 ? <div>Длительность: {Math.floor((o.end-o.start)/100)}:{((o.end-o.start)%100).toString().padStart(2, '0')} {this.getDurWord(false, Math.floor((o.end-o.start)/100))}</div> : <div>На {o.days} {this.getDurWord(true, o.days)}</div>}
          <div>Компания: {o.company}</div>
          <div>Услуга: {o.service}</div>
          <div>Бесплатная отмена {!o.cancelableTime ? "в любое время" : ("до "+new Date(o.cancelableTime).toLocaleString(undefined, {weekday: "long", year: 'numeric', month: '2-digit', day: '2-digit', hour: "2-digit", minute: "2-digit"}))}</div>
          {o.price > 0 ? <span>Цена: <b>{o.price} руб.</b></span> : <></>}
        </div>
      </div>
    );
  }

  renderOrders() {
    return (
      <div>
          {this.state.orders.map(o => this.RenderRow(o))}
      </div>
    );
  }

  render() {
    let orders = this.state.loading
      ? <p><em><FormattedMessage id="loading"/></em></p>
      : this.renderOrders();

    return (
      <div>
        <div>
          <h4 id="tabelLabel" class="leftheader"><FormattedMessage id="your_bookings"/></h4>
        </div>
        {orders}
        <div>
          <h4 id="tabelLabel" class="leftheader"><FormattedMessage id="bookings_history"/></h4>
        </div>
        <div>
          {this.state.history.map(o => this.RenderRow(o))}
        </div>
      </div>
    );
  }

  async populateOrdersData() {
    const token = await authService.getAccessToken();
    var url = `{{mainApiUrl}}api/orders?count=10&status=future`;
    const response = await fetch(url, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, orders: data, loading: false}));

    url = `{{mainApiUrl}}api/orders?count=10&status=history`;
    const responseOld = await fetch(url, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const dataOld = await responseOld.json();
    this.setState(prevState => ({...prevState, history: dataOld, loading: false}));
  }
}
